import { PathUtils } from 'slate';
export default function moveNodeTo(editor, dragNodeKey, dropNodeKey) {
  var position = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'before';
  var dragParentNode = editor.value.document.getParent(dragNodeKey);
  var dropParentNode = editor.value.document.getParent(dropNodeKey);
  var dragPath = editor.value.document.getPath(dragNodeKey);
  var dropPath = editor.value.document.getPath(dropNodeKey);
  var newKey = dropParentNode.key;
  var indexOffset = 0;

  if (PathUtils.isEqual(dropPath, dragPath)) {
    return editor;
  } else if (PathUtils.isAfter(dropPath, dragPath)) {
    indexOffset = position === 'after' ? 0 : -1;
    var newIndex = dragParentNode === dropParentNode ? Math.max(dropPath.last() + indexOffset, 0) : dropPath.last() + indexOffset + 1;
    editor.moveNodeByKey(dragNodeKey, newKey, newIndex);
  } else {
    indexOffset = position === 'after' ? 1 : 0;
    editor.moveNodeByKey(dragNodeKey, newKey, dropPath.last() + indexOffset);
  }

  return editor;
}